// Contenido del Centro de ayuda (/game/support): temas y preguntas frecuentes.
// Las respuestas describen cómo funciona hoy juegoxima.com; si algo cambia, actualízalo aquí.

export const SUPPORT_WHATSAPP = ["+1-864-753-6014", "+1-864-346-5333"];
export const SUPPORT_EMAIL = "info@juegoxima.com";

export const SUPPORT_CATEGORIES = [
  { id: "game", icon: "🎲", tone: "cyan", es: ["Cómo se juega", "Reglas, modos, Azar y Ciencia"], en: ["How to play", "Rules, modes, Chance and Science"] },
  { id: "account", icon: "👤", tone: "purple", es: ["Cuenta y acceso", "Registro, correo, contraseña"], en: ["Account & access", "Sign up, email, password"] },
  { id: "coins", icon: "🪙", tone: "gold", es: ["Monedas y Tienda", "Premios, compras, saldo"], en: ["Coins & Store", "Prizes, purchases, balance"] },
  { id: "premium", icon: "💎", tone: "cyan", es: ["Premium y pagos", "PayPal, renovar, cancelar"], en: ["Premium & payments", "PayPal, renew, cancel"] },
  { id: "tournaments", icon: "🏆", tone: "green", es: ["Torneos", "Campeonato, inscripción, fases"], en: ["Tournaments", "Championship, sign-up, stages"] },
  { id: "technical", icon: "🛠️", tone: "red", es: ["Problemas técnicos", "Lentitud, desconexión, móvil"], en: ["Technical issues", "Lag, disconnects, mobile"] },
];

// Temas que se pueden elegir al crear una solicitud (los seis de arriba + dos más).
export const SUPPORT_REQUEST_CATEGORIES = [
  ...SUPPORT_CATEGORIES,
  { id: "suggestion", icon: "💡", tone: "gold", es: ["Sugerencia", "Ideas para mejorar Xima"], en: ["Suggestion", "Ideas to improve Xima"] },
  { id: "other", icon: "❓", tone: "cyan", es: ["Otro tema", "Cualquier otra cosa"], en: ["Other", "Anything else"] },
];

export const SUPPORT_FAQ = [
  {
    id: "rules",
    category: "game",
    popular: true,
    es: {
      q: "¿Dónde aprendo las reglas de Xima?",
      a: "En la sección Aprender tienes las reglas, los modos de juego (Ciencia, Azar y Cienzar), tutoriales y un glosario. También puedes buscar cualquier palabra en el buscador de arriba.",
      action: "Abrir Aprender",
    },
    en: {
      q: "Where can I learn the rules of Xima?",
      a: "The Learn section has the rules, the game modes (Science, Chance and Cienzar), tutorials and a glossary. You can also search any word in the search box above.",
      action: "Open Learn",
    },
    to: "/game/learn",
  },
  {
    id: "play-bot",
    category: "game",
    es: {
      q: "¿Cómo juego contra un bot o contra un amigo?",
      a: "Desde Jugar puedes crear una partida o jugar con un bot cuando quieras. Para jugar con un amigo, entra en Amigos y lánzale un reto, o crea una partida privada y compártele el enlace.",
      action: "Ir a Jugar",
    },
    en: {
      q: "How do I play against a bot or a friend?",
      a: "From Play you can create a game or play a bot any time. To play a friend, open Friends and challenge them, or create a private game and share the link.",
      action: "Go to Play",
    },
    to: "/game/lobby",
  },
  {
    id: "analysis",
    category: "game",
    es: {
      q: "¿Cómo veo la repetición y el análisis de mis partidas?",
      a: "En Historial abre cualquier partida para ver la repetición y pulsa «Analizar partida». Sin Premium tienes 3 análisis nuevos al día; las partidas ya analizadas se pueden volver a ver siempre.",
      action: "Abrir Historial",
    },
    en: {
      q: "How do I watch replays and analyses of my games?",
      a: "In History open any game to watch the replay and press «Analyze game». Without Premium you get 3 new analyses per day; games already analyzed can always be viewed again.",
      action: "Open History",
    },
    to: "/game/history",
  },
  {
    id: "password",
    category: "account",
    popular: true,
    es: {
      q: "Olvidé mi contraseña, ¿qué hago?",
      a: "Escríbenos por WhatsApp o al correo info@juegoxima.com con tu nombre de usuario y el correo de la cuenta. Un administrador comprueba que la cuenta es tuya y te pone una contraseña nueva.",
    },
    en: {
      q: "I forgot my password, what should I do?",
      a: "Message us on WhatsApp or at info@juegoxima.com with your username and the account email. An administrator checks the account is yours and sets a new password for you.",
    },
  },
  {
    id: "two-accounts",
    category: "account",
    es: {
      q: "¿Puedo usar dos cuentas en el mismo navegador?",
      a: "Sí. Cada pestaña puede tener su propia cuenta. Abre una pestaña nueva con juegoxima.com/login?otra-cuenta=1 y entra allí con la otra cuenta.",
    },
    en: {
      q: "Can I use two accounts in the same browser?",
      a: "Yes. Each tab can have its own account. Open a new tab at juegoxima.com/login?otra-cuenta=1 and sign in there with the other account.",
    },
  },
  {
    id: "same-email",
    category: "account",
    es: {
      q: "¿Puedo crear otra cuenta con el mismo correo?",
      a: "Cada correo tiene una sola cuenta. Si te registras con un correo que ya está en uso, Xima te avisa: al verificar la cuenta nueva, la anterior se archiva y ya no se puede usar.",
    },
    en: {
      q: "Can I create another account with the same email?",
      a: "Each email has one account. If you sign up with an email already in use, Xima warns you: once the new account is verified, the old one is archived and can no longer be used.",
    },
  },
  {
    id: "coins-missing",
    category: "coins",
    popular: true,
    es: {
      q: "No recibí las monedas de un torneo o un reto",
      a: "Los premios se pagan cuando termina la partida o el torneo. Si ya terminó y no ves las monedas, crea una solicitud con el tema «Monedas y Tienda» y dinos el torneo o la sala; lo revisamos y te las acreditamos.",
      action: "Crear solicitud",
    },
    en: {
      q: "I didn't get the coins from a tournament or challenge",
      a: "Prizes are paid when the game or tournament ends. If it has ended and you don't see the coins, create a request with the topic «Coins & Store» and tell us the tournament or room; we check it and credit them.",
      action: "Create request",
    },
    request: "coins",
  },
  {
    id: "coins-earn",
    category: "coins",
    es: {
      q: "¿Cómo consigo monedas?",
      a: "Ganando partidas y torneos con premio, con los retos entre amigos y con «Invita y gana» en Amigos: cuando un amigo que invitaste juega su primera partida, recibes monedas.",
      action: "Abrir Amigos",
    },
    en: {
      q: "How do I get coins?",
      a: "By winning games and tournaments with prizes, with challenges between friends and with «Invite & earn» in Friends: when a friend you invited plays their first game, you get coins.",
      action: "Open Friends",
    },
    to: "/game/friends",
  },
  {
    id: "store",
    category: "coins",
    es: {
      q: "¿Qué puedo comprar en la Tienda?",
      a: "Bloques especiales y comunes, animaciones, texturas, tarjetas y el juego de mesa. Lo que compras aparece en Diseñar tablero para que lo pongas en tus partidas.",
      action: "Abrir Tienda",
    },
    en: {
      q: "What can I buy in the Store?",
      a: "Special and common blocks, animations, textures, cards and the board game. What you buy appears in Design board so you can use it in your games.",
      action: "Open Store",
    },
    to: "/game/store",
  },
  {
    id: "premium-what",
    category: "premium",
    popular: true,
    es: {
      q: "¿Qué incluye Premium y cuánto cuesta?",
      a: "Premium cuesta 2 USD al mes con PayPal. Incluye análisis de partidas sin límite (sin Premium son 3 nuevos al día), videos de tus partidas sin límite (sin Premium, 1 al día) y puzzles sin límite (sin Premium, 1 al día).",
      action: "Ver Premium",
    },
    en: {
      q: "What does Premium include and how much is it?",
      a: "Premium costs 2 USD per month with PayPal. It includes unlimited game analyses (3 new per day without it), unlimited videos of your games (1 per day without it) and unlimited puzzles (1 per day without it).",
      action: "See Premium",
    },
    to: "/game/premium",
  },
  {
    id: "premium-activate",
    category: "premium",
    es: {
      q: "Pagué Premium pero no se activó",
      a: "Premium se activa solo al volver de PayPal a Xima. Si cerraste la página antes de volver, no te preocupes: el pago se confirma solo en menos de media hora. Si sigue sin activarse, crea una solicitud con el tema «Premium y pagos».",
      action: "Crear solicitud",
    },
    en: {
      q: "I paid for Premium but it isn't active",
      a: "Premium turns on by itself when you come back from PayPal to Xima. If you closed the page before returning, don't worry: the payment is confirmed automatically within half an hour. If it still isn't active, create a request with the topic «Premium & payments».",
      action: "Create request",
    },
    request: "premium",
  },
  {
    id: "premium-cancel",
    category: "premium",
    es: {
      q: "¿Cómo cancelo Premium?",
      a: "Cancela el pago automático desde tu cuenta de PayPal (Pagos automáticos). Sigues teniendo Premium hasta el final del mes que ya pagaste.",
    },
    en: {
      q: "How do I cancel Premium?",
      a: "Cancel the automatic payment from your PayPal account (Automatic payments). You keep Premium until the end of the month you already paid.",
    },
  },
  {
    id: "tournament-join",
    category: "tournaments",
    popular: true,
    es: {
      q: "¿Cómo me inscribo en un torneo?",
      a: "En Torneos ves todos los torneos abiertos con su modo, tiempo y premio; pulsa uno para entrar. Los campeonatos con fases están en Campeonato.",
      action: "Ver torneos",
    },
    en: {
      q: "How do I join a tournament?",
      a: "In Tournaments you see every open tournament with its mode, time and prize; press one to join. Championships with stages are in Championship.",
      action: "See tournaments",
    },
    to: "/game/play",
  },
  {
    id: "disconnect",
    category: "tournaments",
    es: {
      q: "Me desconecté en medio de una partida, ¿qué hago?",
      a: "Vuelve a entrar lo antes posible desde el mismo navegador para seguir la partida. Si perdiste por un fallo de Xima, crea una solicitud con la sala o el torneo y lo revisamos.",
      action: "Crear solicitud",
    },
    en: {
      q: "I disconnected in the middle of a game, what now?",
      a: "Come back as soon as possible from the same browser to continue the game. If you lost because of a Xima failure, create a request with the room or tournament and we'll check it.",
      action: "Create request",
    },
    request: "tournaments",
  },
  {
    id: "slow",
    category: "technical",
    es: {
      q: "La página va lenta o el tablero no carga",
      a: "Recarga la página y comprueba tu conexión. Funciona mejor con Chrome o Edge actualizados. Si sigue fallando, crea una solicitud diciendo qué aparato y navegador usas.",
      action: "Crear solicitud",
    },
    en: {
      q: "The page is slow or the board won't load",
      a: "Reload the page and check your connection. It works best on an up-to-date Chrome or Edge. If it keeps failing, create a request telling us your device and browser.",
      action: "Create request",
    },
    request: "technical",
  },
  {
    id: "mobile",
    category: "technical",
    es: {
      q: "¿Puedo jugar desde el móvil?",
      a: "Sí. Entra en juegoxima.com desde el navegador del móvil; la web se adapta a la pantalla y tiene su propia barra de menú abajo.",
    },
    en: {
      q: "Can I play on my phone?",
      a: "Yes. Open juegoxima.com in your phone's browser; the site adapts to the screen and has its own menu bar at the bottom.",
    },
  },
  {
    id: "suggestion",
    category: "suggestion",
    es: {
      q: "Tengo una idea para mejorar Xima",
      a: "¡Nos encanta! Crea una solicitud con el tema «Sugerencia» y cuéntanos tu idea. Las leemos todas.",
      action: "Enviar sugerencia",
    },
    en: {
      q: "I have an idea to improve Xima",
      a: "We love that! Create a request with the topic «Suggestion» and tell us your idea. We read them all.",
      action: "Send suggestion",
    },
    request: "suggestion",
  },
];

export const SUPPORT_QUICK_REPLIES = {
  es: [
    "Ya lo revisamos y quedó resuelto. ¡Gracias por avisar!",
    "Lo estamos revisando y te escribimos pronto.",
    "Las monedas ya están en tu cuenta.",
    "¿Nos envías una captura de pantalla por WhatsApp al +1-864-753-6014?",
  ],
  en: [
    "We checked it and it's fixed. Thanks for letting us know!",
    "We're looking into it and will write back soon.",
    "The coins are already in your account.",
    "Could you send us a screenshot on WhatsApp at +1-864-753-6014?",
  ],
};
